import React from 'react'

export const ProjectsPage: React.FC = () => {
  return <></>
}
